/* Initialize product card swatches and image sliders within a given root. */
export const initProductCardSwatches = (root: ParentNode | Document = document) => {
  const cards = root.querySelectorAll?.(".product-card");
  try {
    // Preferred module API
    // @ts-ignore - provided by assets/product-card-swatches.js
    if (window.ProductCardSwatches && typeof window.ProductCardSwatches.initAll === 'function') {
      // @ts-ignore
      window.ProductCardSwatches.initAll(root);
      return;
    }
  } catch {}

  // Fallback: legacy global alias `initProductCard`
  if (!cards || !cards.length) return;
  // @ts-ignore
  if (typeof window.initProductCard !== 'function') return;
  for (const card of cards as unknown as HTMLElement[]) {
    try {
      // @ts-ignore
      window.initProductCard(card);
    } catch {}
  }
};
